import { Button, GridItem } from '@chakra-ui/react';
import { ListRow } from 'components/molecules/ListRow';
import { TextWithTooltip } from 'components/molecules/TextWithTooltip';
import type { SyntheticEvent, FC } from 'react';
import { Customer } from 'types/customer';

type Props = {
  /** 顧客情報 */
  item: Customer;
  /** 顧客環境URLボタンがクリック可能かどうか */
  disableCustomerPoseidonLinkButton: boolean;
  /** 行クリックイベントのハンドラ */
  handleClickCustomer: () => void;
  /** 顧客環境URLボタンがクリックした時の`onClick`処理 */
  handleClickCustomerPoseidonLinkButton: (
    e: SyntheticEvent<HTMLButtonElement>,
  ) => void;
};

export const CustomerListItem: FC<Props> = ({
  item,
  disableCustomerPoseidonLinkButton,
  handleClickCustomer,
  handleClickCustomerPoseidonLinkButton,
}) => (
  <ListRow onClick={handleClickCustomer} templateColumns="1fr 2fr 3fr 1fr 1fr">
    <GridItem>
      <TextWithTooltip text={item.id.toString()} />
    </GridItem>
    <GridItem>
      <TextWithTooltip
        text={item.name}
        textMaxWidth="400px"
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
    <GridItem>
      <TextWithTooltip
        text={item.detail}
        textMaxWidth="500px"
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
    <GridItem>
      <TextWithTooltip
        text={item.status ? '契約中' : '解約済み'}
        textMaxWidth="500px"
        visibleTooltip
        tooltipMaxWidth="600px"
      />
    </GridItem>
    <GridItem>
      <Button
        as="a"
        target="_blank"
        style={{ textDecoration: 'none' }}
        href={item.poseidon_url}
        rel="noreferrer noopener nofollow"
        onClick={handleClickCustomerPoseidonLinkButton}
        isDisabled={disableCustomerPoseidonLinkButton}
        size="sm"
      >
        開く
      </Button>
    </GridItem>
  </ListRow>
);
